import Vue from "vue";
import App from "./App.vue";

//设置默认语言是英文

new Vue({ render: (h) => h(App) }).$mount("#app");
